// Configurações de ambiente
const config = {
  // URL do Google Apps Script para envio de formulário
  SPREADSHEET_URL: 'https://script.google.com/macros/s/AKfycbwZE6x7iQ1jliHGzCVIW2vpDCMk3a_8b7Z8nErz1KoQ_Y4eKyDJPGnpsvWExY4aDguPPQ/exec'
};

// Debug em desenvolvimento
if (process.env.NODE_ENV === 'development') {
  console.log('Configurações carregadas:', config);
}

export default config;